export const SCREEN_NAME_CATEGORY = {
    GIFTING: "gifting-checkout",
};
